import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Scroller from './Dashboard/Scroller';

import StatesPieChart from './Dashboard/StatesPieChart';
import StatesTable from './Dashboard/StatesTable';
import ActiveFindingsTable from './Dashboard/ActiveFindingsTable';
import WorldMap from './Dashboard/Worldmap';
import LocationsTable from './Dashboard/LocationsTable';
import TrendsGraph from './Dashboard/TrendsGraph';

import * as Actions from '../../redux/actions';

import Safe from '../Components/Safe';
import Loading from '../Components/Loading';
import DateRangeSelection from '../Components/DateRangeSelection';
import CriteriaSelection from '../Components/CriteriaSelection';
import NewsStory from '../Components/NewsStory';
import ActivityStory from '../Components/ActivityStory';

import Flyout from '../Components/Flyout';
import Collapse from '../Components/Collapse';
import FindingDetail from '../Components/FindingDetail';

class DashboardPageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flyoutEvent: null,
    };

    this.fetch = this.fetch.bind(this);
    this.retryDataQuery = this.retryDataQuery.bind(this);
    this.viewDetail = this.viewDetail.bind(this);
    this.closeDetail = this.closeDetail.bind(this);
    this.update = this.update.bind(this);
    this.renderPageTitle = this.renderPageTitle.bind(this);
    this.renderPageDescription = this.renderPageDescription.bind(this);
    this.renderFilters = this.renderFilters.bind(this);
    this.renderNews = this.renderNews.bind(this);
    this.renderAnalystResponderTrending = this.renderAnalystResponderTrending.bind(this);
    this.renderManagerTrending = this.renderManagerTrending.bind(this);
    this.renderActivityFeed = this.renderActivityFeed.bind(this);
    this.renderTrending = this.renderTrending.bind(this);
  }

  componentDidMount() {
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    let fetch = false;
    if (prevProps.orgId !== this.props.orgId) {
      fetch = true;
    } else if (!_.isEqual(prevProps.payload, this.props.payload)) {
      fetch = true;
    }
    if (fetch) this.fetch();
  }

  fetch() {
    const { dispatch, orgId, user } = this.props;
    dispatch(Actions.DataQuery.processDataQueries(orgId));
    dispatch(Actions.Findings.fetchFindings({
      personId: user.id,
      orgId,
    }));
  }

  retryDataQuery(dataQueryKey) {
    const { dispatch, orgId } = this.props;
    dispatch(Actions.DataQuery.processDataQueries(orgId, dataQueryKey));
  }

  update(data = {}) {
    // const { dispatch } = this.props;
    const { findings = [] } = this.props.data || {};
    const newEvents = findings.slice();
    _.each(newEvents, (e, i) => {
      if (e.id === data.id) {
        newEvents[i] = data;
        if (this.state.flyoutEvent && this.state.flyoutEvent.id === data.id) {
          this.viewDetail(data);
        }
      }
    });
    // @TODO: make api request to update user in the db
    // dispatch({ type: 'PAGE_DATA_PART', part: 'findings', data: newEvents });
  }

  viewDetail(flyoutEvent) {
    this.setState({ flyoutEvent });
  }

  viewTimeline(finding) {
    const { routeToPage, orgId } = this.props;
    routeToPage({
      payload: {
        orgId,
        toplevel: 'query',
        secondlevel: 'threats',
        id1: finding.id,
      },
    });
  }

  closeDetail() {
    this.setState({ flyoutEvent: null });
  }

  // @TODO: v1.0 of dashboard will not have filters
  renderFilters(filters, applyFilter) {
    return (
      <div className='row filters'>
        <div className='col-5 left-column' style={{ zIndex: 999 }}>
          <div className='column-header' style={{ marginBottom: '15px', display: 'none' }}>
            <div className='uppercase'>Filters</div>
            <i
              className='fas fa-filter'
              style={{ position: 'absolute', right: '15px', top: '5px' }}
            />
          </div>
          <div className='filters'>
            <DateRangeSelection
              applyFilter={applyFilter}
              fetch={this.fetch}
              selectionRange={filters.selectionRange}
            />
          </div>
        </div>
        <div className='col-5 middle-column'>
          <CriteriaSelection
            applyFilter={applyFilter}
            fetch={this.fetch}
            criteria={filters.criteria}
          />
        </div>
        <div className='col-2 align-self-center right-column'>
          <div className='reports align-self-center'>
            <div>
              <a href='#download-report' target='_blank'>
                Export Report
                <i className='fas fa-share-square' />
              </a>
            </div>
            <div>
              <a href='#automatic-report' target='_blank'>
                Create Automatic Report
                <i className='fas fa-share-square' />
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderNews(news, user) {
    return (
      <React.Fragment>
        <div className='column-header'>
          <div className='uppercase'>News</div>
        </div>
        <div className='column-content padding16'>
          {_.map(news || [], n => <NewsStory user={user} key={n.id} {...n} />)}
        </div>
      </React.Fragment>
    );
  }

  // @TODO: news and activity are potentially getting phased out
  renderActivityFeed(activity) {
    return (
      <React.Fragment>
        <div className='column-header' style={{ marginTop: '28px' }}>
          <div className='uppercase'>Activity Feed</div>
        </div>
        <div className='column-content padding16'>
          {_.map(activity || [], n => <ActivityStory key={n.id} {...n} />)}
        </div>
      </React.Fragment>
    );
  }

  renderPageTitle(toplevel, secondlevel) {
    return (
      <span className='page-title'>
        <h1>
          <Safe
            render
            safe
            path={`pages.${toplevel}.${secondlevel}`}
            value='title'
          />
        </h1>
      </span>
    );
  }

  renderAnalystResponderTrending(dataQueries) {
    return (
      <div className='column-content'>
        <Collapse title='Finding States' height='100%'>
          <StatesPieChart chartData={dataQueries.DASHBOARD_PIE_CHART} />
        </Collapse>
        <Collapse title='Finding Source Locations' height='100%'>
          <WorldMap mapData={dataQueries.DASHBOARD_WORLD_MAP} />
        </Collapse>
      </div>
    );
  }

  renderPageDescription(toplevel, secondlevel) {
    return (
      <span className='page-description'>
        <p>| &nbsp;
          <Safe
            render
            safe
            path={`pages.${toplevel}.${secondlevel}`}
            value='description'
          />
        </p>
      </span>
    );
  }

  renderManagerTrending(data, reports, dataQueries) {
    return (
      <React.Fragment>
        <div className='column-content'>
          <Collapse
            id='dashboard-5'
            title='Threats Detected'
            height='100%'
          >
            <TrendsGraph
              trendData={dataQueries.DASHBOARD_FINDINGS_TREND}
              graphData={dataQueries.DASHBOARD_FINDINGS_DETECTED_GRAPH}
              type='threats'
              colorPallete={1}
              handleRetry={() => {
                this.retryDataQuery('DASHBOARD_FINDINGS_TREND');
                this.retryDataQuery('DASHBOARD_FINDINGS_DETECTED_GRAPH');
              }}
            />
            <StatesTable
              tableData={dataQueries.DASHBOARD_RECENT_THREATS_TABLE}
              viewDetail={this.viewDetail}
              handleRetry={() => {
                this.retryDataQuery('DASHBOARD_RECENT_THREATS_TABLE');
              }}
            />
          </Collapse>
        </div>
        <div className='column-content'>
          <Collapse
            id='dashboard-6'
            title='Suspects Opened'
            height='100%'
          >
            <TrendsGraph
              trendData={dataQueries.DASHBOARD_FINDINGS_TREND}
              graphData={dataQueries.DASHBOARD_FINDINGS_DETECTED_GRAPH}
              type='suspects'
              handleRetry={() => {
                this.retryDataQuery('DASHBOARD_FINDINGS_TREND');
                this.retryDataQuery('DASHBOARD_FINDINGS_DETECTED_GRAPH');
              }}
            />
          </Collapse>
        </div>
        <div className='column-content'>
          <Collapse
            id='dashboard-7'
            title='Finding Source Locations'
            height='100%'
          >
            <div className='chart-container threat-source-locations'>
              <span className='span full'>
                <span className='span half'>
                  <WorldMap
                    mapData={dataQueries.DASHBOARD_WORLD_MAP}
                    handleRetry={() => {
                      this.retryDataQuery('DASHBOARD_WORLD_MAP');
                    }}
                  />
                </span>
                <span className='span half'>
                  <LocationsTable
                    tableData={dataQueries.DASHBOARD_LOCATIONS_TABLE}
                    handleRetry={() => {
                      this.retryDataQuery('DASHBOARD_LOCATIONS_TABLE');
                    }}
                  />
                </span>
              </span>
            </div>
          </Collapse>
        </div>
        <div className='column-content'>
          <Collapse
            id='dashboard-6'
            title='Current Active Findings'
            height='100%'
          >
            <ActiveFindingsTable
              tableData={dataQueries.DASHBOARD_CURRENT_ACTIVE_FINDINGS_TABLE}
              handleRetry={() => {
                this.retryDataQuery('DASHBOARD_CURRENT_ACTIVE_FINDINGS_TABLE');
              }}
            />
          </Collapse>
        </div>
      </React.Fragment>
    );
  }

  renderTrending(secondlevel, data, reports, dataQueries) {
    return (
      <div className="trending">
        <div className='column-header'>
          <div className='uppercase'>Trending</div>
        </div>
        {['analyst', 'responder'].includes(secondlevel) ?
          this.renderAnalystResponderTrending(dataQueries) : null }
        {['manager'].includes(secondlevel) ?
          this.renderManagerTrending(data, reports, dataQueries) : null }
      </div>
    );
  }

  render() {
    const {
      data = {},
      dataQueries = {},
      loading = false,
      payload = {},
    } = this.props;

    const {
      toplevel,
      secondlevel,
    } = payload;

    const {
      flyoutEvent = null,
    } = this.state;

    const {
      reports = [],
      assignableUsers = [{ // @TODO @XXX
        username: 'responder',
        firstname: 'Rey',
        lastname: 'Responda',
        role: 'responder',
      }, {
        username: 'analyst2',
        firstname: 'Alicia',
        lastname: 'Analysta',
        role: 'analyst',
      }, {
        username: 'analyst3',
        firstname: 'Alejandro',
        lastname: 'Analysto',
        role: 'analyst',
      }, {
        username: 'manager',
        firstname: 'Ollie',
        lastname: 'Operata',
        role: 'manager',
      }],
    } = data;


    let loadingStyles = {};
    if (loading) {
      loadingStyles = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        marginTop: '50px',
      };
    }
    const scrollerStats = dataQueries.DASHBOARD_SCROLLER_STATS.visualizationData;
    return (
      <React.Fragment>
        <span
          className='dashboard'
          style={{ ...loadingStyles }}
        >
          {loading &&
            <Loading />
          }
          {!loading &&
            <div style={{ position: 'relative' }}>
              <div className='page-header'>
                {this.renderPageTitle(toplevel, secondlevel)}
                {this.renderPageDescription(toplevel, secondlevel)}
              </div>
              <hr />
              {/* v1.0 of dashboard will not have filters
                this.renderFilters(filters, applyFilter)
              */}
              <Scroller scrollerStats={scrollerStats} />
              <div className='dashboard-content'>
                {['analyst', 'responder', 'manager'].includes(secondlevel) ?
                  this.renderTrending(secondlevel, data, reports, dataQueries) : null }
                {/* @TODO: news and activity are potentially getting phased out
                  <div className='col-2 right-column'>
                    { this.renderNews(news, user) }
                    {['manager'].includes(secondlevel) ?
                      this.renderActivityFeed(activity) : null
                    }
                  </div>
                */}
              </div>
              <Flyout handleClose={this.closeDetail} isOpen={flyoutEvent ? true : false}>
                <FindingDetail
                  finding={flyoutEvent || {}}
                  assignableUsers={assignableUsers}
                  update={this.update}
                />
              </Flyout>
            </div>
          }
        </span>
      </React.Fragment>
    );
  }
}

DashboardPageView.propTypes = {
  orgId: PropTypes.string.isRequired,
  getState: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
  user: PropTypes.shape({}),
  payload: PropTypes.shape({}),
  filters: PropTypes.shape({}),
  loading: PropTypes.bool,
  pageTitle: PropTypes.string,
  routeToPage: PropTypes.func.isRequired,
  dataQueries: PropTypes.shape({}),
};

DashboardPageView.defaultProps = {
  user: {},
  payload: {},
  data: {},
  filters: {},
  loading: false,
  pageTitle: '',
  dataQueries: {},
};

export default DashboardPageView;



// WEBPACK FOOTER //
// ./src/views/Pages/DashboardPageView.js